export const SERP_INTERACTION_FLAG = 'nestoria_serp_interaction';

export function setInteractionFlag(interactionType: string): void {
    sessionStorage.setItem(SERP_INTERACTION_FLAG, interactionType);
}
